import parse from 'html-react-parser'
export default function CustomButton(props) {
  const { text ,fn, type, transparent, disabled} = props

  function classNameTransparent() {
    let classStr = 'customBtn'
    if (type === 'small') {
      classStr += ' customBtnTransparentSmall'
    }
    else classStr += ' customBtnTransparent'
    
    if (disabled) {
      classStr += ' customBtnDisable'
    }

    return classStr
  }

  function classNamePink() {
    let classStr = 'customBtn'
    if (type === 'small') {
      classStr += ' customBtnPinkSmall'
    }
    else if (type === 'medium') {
      classStr += ' customBtnPinkMedium'
    }
    else classStr += ' customBtnPinkLarge'
    
    return classStr
  }
  return (
    <>
      {
        transparent
          ? <div className={classNameTransparent()} onClick={() => fn ? fn() : {}}>
              {parse(text)}
            </div>
          : <div className={classNamePink()} onClick={() => fn ? fn() : {}}>
              {parse(text)}
            </div>
      }
    </>
    
  )
}